export default "__VITE_ASSET__DWy$9BzX__"